export interface ExperienceItem {
  title: string
  duration: string
  responsibilities: string[]
}

export const experience: ExperienceItem[] = [
  {
    title: 'Software Developer IT@Himalaya',
    duration: 'Aug 2021 – Present',
    responsibilities: [
      'Progressed from Node.js Intern to Software Developer, contributing to a long-term enterprise product.',
      'Built and enhanced dynamic UI modules using JavaScript, jQuery, and AngularJS, integrated with ASP.NET backend services.',
      'Worked extensively with Microsoft SQL Server and SQLite, focusing on reliable database transactions and data integrity.',
      'Contributed to the SmartFlow low-code builder, enabling non-technical users to create forms and workflows efficiently.',
      'Supported migration from SVN to Azure Git and adoption of modern tooling such as Webpack.',
    ],
  },
]
